export default __webpack_public_path__ + "static/rsz_logo-space3ac-8dff680c1a7752f8e3012eee7ea15521.png";